import { render, staticRenderFns } from "./demo-tracking.vue?vue&type=template&id=ba191f2a&scoped=true&"
import script from "./demo-tracking.vue?vue&type=script&lang=js&"
export * from "./demo-tracking.vue?vue&type=script&lang=js&"
import style0 from "./demo-tracking.vue?vue&type=style&index=0&id=ba191f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba191f2a",
  null
  
)

export default component.exports